import { useEffect, useState } from "react";
import {
  Table,
  Button,
  Spin,
  Alert,
  Space,
  message,
} from "antd";
import {
  ReloadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getPanchayatGSCompliance, getGPwiseGSComplianceBDPO } from "../api/User";

const DistrictwiseSpecialGSComplianceSachiv = ({ dateFilter }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Read synchronously from sessionStorage — no async state race
  const roleId = sessionStorage.getItem("role_id");
  const userInfo = {
    district_code: sessionStorage.getItem("district_code"),
    district_name: sessionStorage.getItem("district_name"),
    block_code: sessionStorage.getItem("block_code"),
    block_name: sessionStorage.getItem("block_name"),
    panchayat_code: sessionStorage.getItem("panchayat_code"),
    panchayat_name: sessionStorage.getItem("panchayat_name"),
  };

  const numberSorter = (a, b, key) => {
    const valA = a[key] || 0;
    const valB = b[key] || 0;
    return valA - valB;
  };

  const stringSorter = (a, b, key) => {
    const valA = (a[key] || '').toString().toLowerCase();
    const valB = (b[key] || '').toString().toLowerCase();
    return valA.localeCompare(valB);
  };

  // Check if current user is Gram Sachiv
  const isGramSachiv = roleId === "2";

  /* ================= GRAM SACHIV PANCHAYAT COLUMNS ================= */
  const gramSachivColumns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      width: 60,
      align: "center",
      fixed: "left",
      sorter: (a, b) => numberSorter(a, b, 'sr_no'),
    },
    {
      title: "District",
      dataIndex: "district_name",
      width: 150,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'district_name'),
    },
    {
      title: "Block",
      dataIndex: "block_name",
      width: 160,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'block_name'),
    },
    {
      title: "Gram Panchayat",
      dataIndex: "gp_name",
      width: 200,
      align: "center",
      fixed: "left",
      sorter: (a, b) => stringSorter(a, b, 'gp_name'),

    },
    {
      title: "1st Meeting",
      children: [
        {
          title: "No. of GPs conducted gram sabha",
          dataIndex: "m1_conducted",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm1_conducted'),

        },
        {
          title: "No of GPs updated voters, mom, Attendance",
          dataIndex: "m1_updated",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm1_updated'),

        },
        {
          title: "Quorum Fullfilled",
          dataIndex: "m1_quorum_yes",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes'),

        },
        {
          title: "Quorum Failed",
          dataIndex: "m1_quorum_no",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no'),

        },
      ],
    },
    {
      title: "2nd Meeting",
      children: [
        {
          title: "No. of GPs conducted gram sabha",
          dataIndex: "m2_conducted",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm2_conducted'),

        },
        {
          title: "No of GPs updated voters, mom, Attendance",
          dataIndex: "m2_updated",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm2_updated'),

        },
        {
          title: "Quorum Fullfilled",
          dataIndex: "m2_quorum_yes",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes'),

        },
        {
          title: "Quorum Failed",
          dataIndex: "m2_quorum_no",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no'),

        },
      ],
    },
    {
      title: "3rd Meeting",
      children: [
        {
          title: "No. of GPs conducted gram sabha",
          dataIndex: "m3_conducted",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm3_conducted'),

        },
        {
          title: "No of GPs updated voters, mom, Attendance",
          dataIndex: "m3_updated",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm3_updated'),

        },
        {
          title: "Quorum Fullfilled",
          dataIndex: "m3_quorum_yes",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes'),

        },
        {
          title: "Quorum Failed",
          dataIndex: "m3_quorum_no",
          width: 90,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no'),

        },
      ],
    },
    {
      title: "Never Rescheduled those Failed in 1st Meeting",
      dataIndex: "never_rescheduled",
      width: 140,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),

    },
  ];

  /* ================= BLOCK LEVEL COLUMNS (Now showing panchayat-level data) ================= */
  const blockColumns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      width: 60,
      align: "center",
      fixed: "left",
      sorter: (a, b) => numberSorter(a, b, 'sr_no'),
    },
    {
      title: "District",
      dataIndex: "district_name",
      width: 150,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'district_name'),
    },
    {
      title: "Block",
      dataIndex: "block_name",
      width: 160,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'block_name'),
    },
    {
      title: "Gram Panchayat",
      dataIndex: "gp_name",
      width: 200,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'gp_name'),
      render: (val) => <span style={{ fontWeight: 500 }}>{val || "N/A"}</span>,
    },
    {
      title: "1st Meeting",
      children: [
        { title: "Conducted", dataIndex: "m1_conducted", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_conducted') },
        { title: "Updated", dataIndex: "m1_updated", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_updated') },
        { title: "Quorum Yes", dataIndex: "m1_quorum_yes", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes') },
        { title: "Quorum No", dataIndex: "m1_quorum_no", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no') },
      ],
    },
    {
      title: "2nd Meeting",
      children: [
        { title: "Conducted", dataIndex: "m2_conducted", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_conducted') },
        { title: "Updated", dataIndex: "m2_updated", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_updated') },
        { title: "Quorum Yes", dataIndex: "m2_quorum_yes", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes') },
        { title: "Quorum No", dataIndex: "m2_quorum_no", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no') },
      ],
    },


    {
      title: "3rd Meeting",
      children: [
        { title: "Conducted", dataIndex: "m3_conducted", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_conducted') },
        { title: "Updated", dataIndex: "m3_updated", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_updated') },
        { title: "Quorum Yes", dataIndex: "m3_quorum_yes", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes') },
        { title: "Quorum No", dataIndex: "m3_quorum_no", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no') },
      ],
    },
    {
      title: "Never Rescheduled",
      dataIndex: "never_rescheduled",
      width: 140,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),
    },
  ];

  // Get columns based on role
  const getColumns = () => {
    return isGramSachiv ? gramSachivColumns : blockColumns;
  };


  /* ================= FETCH GRAM SACHIV PANCHAYAT DATA ================= */
  const fetchGramSachivData = async (currentDateFilter) => {
    try {
      setLoading(true);
      setError(null);

      const token = sessionStorage.getItem("token");
      if (!token) {
        message.error("Authentication required");
        return;
      }

      if (!userInfo.district_code || !userInfo.block_code || !userInfo.panchayat_code) {
        setError("User location information not found. Please contact administrator.");
        message.error("Location information missing");
        return;
      }

      console.log("Fetching Gram Sachiv panchayat data...");
      console.log("User Info:", userInfo);

      // Fetch GP level data for Gram Sachiv's panchayat
      const result = await getGPwiseGSComplianceBDPO(token, userInfo.district_code, userInfo.block_code, currentDateFilter);

      if (result.success) {
        // Filter only this Gram Sachiv's panchayat
        const panchayatData = result.result.filter(item =>
          item.panchayat_code === userInfo.panchayat_code
        );

        const formatted = panchayatData.map((item, index) => ({
          ...item,
          key: item.panchayat_code || `gp-${index}`,
          sr_no: index + 1,
          district_name: item.district_name || userInfo.district_name,
          block_name: item.block_name || userInfo.block_name,
          gp_name: item.panchayat_name || userInfo.panchayat_name || "N/A",
          m1_conducted: item.m1_conducted || 0,
          m1_updated: item.m1_updated || 0,
          m1_quorum_yes: item.m1_quorum_yes || 0,
          m1_quorum_no: item.m1_quorum_no || 0,
          m2_conducted: item.m2_conducted || 0,
          m2_updated: item.m2_updated || 0,
          m2_quorum_yes: item.m2_quorum_yes || 0,
          m2_quorum_no: item.m2_quorum_no || 0,
          m3_conducted: item.m3_conducted || 0,
          m3_updated: item.m3_updated || 0,
          m3_quorum_yes: item.m3_quorum_yes || 0,
          m3_quorum_no: item.m3_quorum_no || 0,
          never_rescheduled: item.never_rescheduled || 0,
        }));

        setData(formatted);

        if (formatted.length > 0) {
          message.success(`Loaded data for ${formatted[0].gp_name}`);
        } else {
          message.warning("No data found for your Gram Panchayat");
        }
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  /* ================= FETCH BLOCK LEVEL DATA ================= */
  const fetchBlockReportData = async (currentDateFilter) => {
    try {
      setLoading(true);
      setError(null);

      const token = sessionStorage.getItem("token");
      if (!token) {
        message.error("Authentication required");
        return;
      }

      console.log("Fetching BDPO panchayat-wise GS compliance data...");

      const res = await getPanchayatGSCompliance(token, currentDateFilter);

      console.log("API Response:", res);

      if (res.success && res.result) {
        const formatted = res.result.map((item, index) => ({
          ...item,
          key: item.panchayat_code || `panchayat-${index}`,
          sr_no: index + 1,
          district_code: item.district_code,
          district_name: item.district_name || "N/A",
          block_code: item.block_code,
          block_name: item.block_name || "N/A",
          gp_name: item.gp_name || item.panchayat_name || "N/A",
          panchayat_code: item.panchayat_code,
          m1_conducted: item.m1_conducted || 0,
          m1_updated: item.m1_updated || 0,
          m1_quorum_yes: item.m1_quorum_yes || 0,
          m1_quorum_no: item.m1_quorum_no || 0,
          m2_conducted: item.m2_conducted || 0,
          m2_updated: item.m2_updated || 0,
          m2_quorum_yes: item.m2_quorum_yes || 0,
          m2_quorum_no: item.m2_quorum_no || 0,
          m3_conducted: item.m3_conducted || 0,
          m3_updated: item.m3_updated || 0,
          m3_quorum_yes: item.m3_quorum_yes || 0,
          m3_quorum_no: item.m3_quorum_no || 0,
          never_rescheduled: item.never_rescheduled || 0,
        }));

        setData(formatted);
        message.success(`Loaded ${formatted.length} panchayat records`);
      } else {
        const errorMsg = res.message || "Failed to fetch compliance data";
        setError(errorMsg);
        message.error(errorMsg);
      }
    } catch (err) {
      console.error("Fetch Error:", err);
      const errorMsg = err.message || "Failed to fetch data";
      setError(errorMsg);
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  // Fetch based on role whenever dateFilter changes
  useEffect(() => {
    if (isGramSachiv) {
      if (userInfo.panchayat_code) {
        fetchGramSachivData(dateFilter);
      } else {
        fetchBlockReportData(dateFilter);
      }
    } else {
      fetchBlockReportData(dateFilter);
    }
  }, [dateFilter]);

  /* ================= EXPORT PDF ================= */
  const handleExportPDF = () => {
    if (!data.length) return;

    const doc = new jsPDF("landscape");
    doc.setFontSize(16);

    // Set title based on role
    const title = isGramSachiv
      ? `Gram Panchayat Meeting Compliance ${userInfo.panchayat_name || ''}`
      : "Blockwise Special Gram Sabha Meeting Compliance (BDPO)";

    doc.text(title, 148, 15, { align: "center" });

    if (isGramSachiv) {
      // Gram Sachiv PDF export
      const headers = [
        "Sr. No.",
        "District",
        "Block",
        "Gram Panchayat",
        "No. of gps Conducted in 1st meeting: ",
        "No. of gps Updated in 1st meeting: ",
        "No. of gps quorum fullfilled in 1st meeting: ",
        "No. of gps quorum failed in 1st meeting: ",
        "No. of gps Conducted in 2nd meeting: ",
        "No. of gps Updated in 2nd meeting: ",
        "No. of gps quorum fullfilled in 2nd meeting: ",
        "No. of gps quorum failed in 2nd meeting: ",
        "No. of gps Conducted in 3rd meeting: ",
        "No. of gps Updated in 3rd meeting: ",
        "No. of gps quorum fullfilled in 3rd meeting: ",
        "No. of gps quorum failed in 3rd meeting: ",
        "Never Rescheduled those Failed in 1st Meeting"
      ];

      const body = data.map(row => [
        row.sr_no,
        row.district_name,
        row.block_name,
        row.gp_name,
        row.m1_conducted || 0,
        row.m1_updated || 0,
        row.m1_quorum_yes || 0,
        row.m1_quorum_no || 0,
        row.m2_conducted || 0,
        row.m2_updated || 0,
        row.m2_quorum_yes || 0,
        row.m2_quorum_no || 0,
        row.m3_conducted || 0,
        row.m3_updated || 0,
        row.m3_quorum_yes || 0,
        row.m3_quorum_no || 0,
        row.never_rescheduled || 0,
      ]);

      // Add grand total row
      body.push([
        "GRAND TOTAL",
        "",
        "",
        "",
        gramSachivTotals.m1_conducted,
        gramSachivTotals.m1_updated,
        gramSachivTotals.m1_quorum_yes,
        gramSachivTotals.m1_quorum_no,
        gramSachivTotals.m2_conducted,
        gramSachivTotals.m2_updated,
        gramSachivTotals.m2_quorum_yes,
        gramSachivTotals.m2_quorum_no,
        gramSachivTotals.m3_conducted,
        gramSachivTotals.m3_updated,
        gramSachivTotals.m3_quorum_yes,
        gramSachivTotals.m3_quorum_no,
        gramSachivTotals.never_rescheduled,
      ]);

      autoTable(doc, {
        head: [headers],
        body,
        startY: 25,
        theme: "grid",
        headStyles: { fillColor: [22, 119, 255] },
        styles: { fontSize: 8 },
        didParseCell: function (data) {
          if (data.row.index === body.length - 1) {
            data.cell.styles.fillColor = [230, 247, 255];
            data.cell.styles.fontStyle = "bold";
          }
        }
      });

      doc.save(`Gram_Panchayat_Compliance_${userInfo.panchayat_name?.replace(/\s+/g, '_') || 'MyGP'}.pdf`);
    } else {
      // Block level PDF export (existing code)
      const headers = [
        "Sr. No.",
        "District",
        "Block",
        "No. of Panchayats",
        "No. of gps Conducted in 1st meeting: ",
        "No. of gps Updated in 1st meeting: ",
        "No. of gps quorum fullfilled in 1st meeting: ",
        "No. of gps quorum failed in 1st meeting: ",
        "No. of gps Conducted in 2nd meeting: ",
        "No. of gps Updated in 2nd meeting: ",
        "No. of gps quorum fullfilled in 2nd meeting: ",
        "No. of gps quorum failed in 2nd meeting: ",
        "No. of gps Conducted in 3rd meeting: ",
        "No. of gps Updated in 3rd meeting: ",
        "No. of gps quorum fullfilled in 3rd meeting: ",
        "No. of gps quorum failed in 3rd meeting: ",
        "Never Rescheduled those Failed in 1st Meeting"
      ];

      const body = data.map(row => [
        row.sr_no,
        row.district_name,
        row.block_name,
        row.gp_count || 0,
        row.m1_conducted || 0,
        row.m1_updated || 0,
        row.m1_quorum_yes || 0,
        row.m1_quorum_no || 0,
        row.m2_conducted || 0,
        row.m2_updated || 0,
        row.m2_quorum_yes || 0,
        row.m2_quorum_no || 0,
        row.m3_conducted || 0,
        row.m3_updated || 0,
        row.m3_quorum_yes || 0,
        row.m3_quorum_no || 0,
        row.never_rescheduled || 0,
      ]);

      body.push([
        "GRAND TOTAL",
        "",
        "",
        blockTotals.gp_count,
        blockTotals.m1_conducted,
        blockTotals.m1_updated,
        blockTotals.m1_quorum_yes,
        blockTotals.m1_quorum_no,
        blockTotals.m2_conducted,
        blockTotals.m2_updated,
        blockTotals.m2_quorum_yes,
        blockTotals.m2_quorum_no,
        blockTotals.m3_conducted,
        blockTotals.m3_updated,
        blockTotals.m3_quorum_yes,
        blockTotals.m3_quorum_no,
        blockTotals.never_rescheduled,
      ]);

      autoTable(doc, {
        head: [headers],
        body,
        startY: 25,
        theme: "grid",
        headStyles: { fillColor: [22, 119, 255] },
        styles: { fontSize: 8 },
        didParseCell: function (data) {
          if (data.row.index === body.length - 1) {
            data.cell.styles.fillColor = [230, 247, 255];
            data.cell.styles.fontStyle = "bold";
          }
        }
      });

      doc.save("BDPO_Special_GS_Compliance.pdf");
    }
  };

  /* ================= EXPORT EXCEL ================= */
  const handleExportExcel = () => {
    if (!data.length) return;

    let excelData;

    if (isGramSachiv) {
      // Gram Sachiv Excel export
      excelData = data.map(row => ({
        "Sr. No.": row.sr_no,
        "District": row.district_name,
        "Block": row.block_name,
        "Gram Panchayat": row.gp_name,
        "1st Meeting Conducted": row.m1_conducted || 0,
        "1st Meeting Updated": row.m1_updated || 0,
        "1st Meeting Quorum Yes": row.m1_quorum_yes || 0,
        "1st Meeting Quorum No": row.m1_quorum_no || 0,
        "2nd Meeting Conducted": row.m2_conducted || 0,
        "2nd Meeting Updated": row.m2_updated || 0,
        "2nd Meeting Quorum Yes": row.m2_quorum_yes || 0,
        "2nd Meeting Quorum No": row.m2_quorum_no || 0,
        "3rd Meeting Conducted": row.m3_conducted || 0,
        "3rd Meeting Updated": row.m3_updated || 0,
        "3rd Meeting Quorum Yes": row.m3_quorum_yes || 0,
        "3rd Meeting Quorum No": row.m3_quorum_no || 0,
        "Never Rescheduled": row.never_rescheduled || 0,
      }));

      excelData.push({
        "Sr. No.": "GRAND TOTAL",
        "District": "",
        "Block": "",
        "Gram Panchayat": "",
        "1st Meeting Conducted": gramSachivTotals.m1_conducted,
        "1st Meeting Updated": gramSachivTotals.m1_updated,
        "1st Meeting Quorum Yes": gramSachivTotals.m1_quorum_yes,
        "1st Meeting Quorum No": gramSachivTotals.m1_quorum_no,
        "2nd Meeting Conducted": gramSachivTotals.m2_conducted,
        "2nd Meeting Updated": gramSachivTotals.m2_updated,
        "2nd Meeting Quorum Yes": gramSachivTotals.m2_quorum_yes,
        "2nd Meeting Quorum No": gramSachivTotals.m2_quorum_no,
        "3rd Meeting Conducted": gramSachivTotals.m3_conducted,
        "3rd Meeting Updated": gramSachivTotals.m3_updated,
        "3rd Meeting Quorum Yes": gramSachivTotals.m3_quorum_yes,
        "3rd Meeting Quorum No": gramSachivTotals.m3_quorum_no,
        "Never Rescheduled": gramSachivTotals.never_rescheduled,
      });
    } else {
      // Block level Excel export
      excelData = data.map(row => ({
        "Sr. No.": row.sr_no,
        "District": row.district_name,
        "Block": row.block_name,
        "No. of Panchayats": row.gp_count || 0,
        "1st Meeting Conducted": row.m1_conducted || 0,
        "1st Meeting Updated": row.m1_updated || 0,
        "1st Meeting Quorum Yes": row.m1_quorum_yes || 0,
        "1st Meeting Quorum No": row.m1_quorum_no || 0,
        "2nd Meeting Conducted": row.m2_conducted || 0,
        "2nd Meeting Updated": row.m2_updated || 0,
        "2nd Meeting Quorum Yes": row.m2_quorum_yes || 0,
        "2nd Meeting Quorum No": row.m2_quorum_no || 0,
        "3rd Meeting Conducted": row.m3_conducted || 0,
        "3rd Meeting Updated": row.m3_updated || 0,
        "3rd Meeting Quorum Yes": row.m3_quorum_yes || 0,
        "3rd Meeting Quorum No": row.m3_quorum_no || 0,
        "Never Rescheduled": row.never_rescheduled || 0,
      }));

      excelData.push({
        "Sr. No.": "GRAND TOTAL",
        "District": "",
        "Block": "",
        "No. of Panchayats": blockTotals.gp_count,
        "1st Meeting Conducted": blockTotals.m1_conducted,
        "1st Meeting Updated": blockTotals.m1_updated,
        "1st Meeting Quorum Yes": blockTotals.m1_quorum_yes,
        "1st Meeting Quorum No": blockTotals.m1_quorum_no,
        "2nd Meeting Conducted": blockTotals.m2_conducted,
        "2nd Meeting Updated": blockTotals.m2_updated,
        "2nd Meeting Quorum Yes": blockTotals.m2_quorum_yes,
        "2nd Meeting Quorum No": blockTotals.m2_quorum_no,
        "3rd Meeting Conducted": blockTotals.m3_conducted,
        "3rd Meeting Updated": blockTotals.m3_updated,
        "3rd Meeting Quorum Yes": blockTotals.m3_quorum_yes,
        "3rd Meeting Quorum No": blockTotals.m3_quorum_no,
        "Never Rescheduled": blockTotals.never_rescheduled,
      });
    }

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();

    const sheetName = isGramSachiv ? "Panchayat Compliance" : "Block Compliance";
    XLSX.utils.book_append_sheet(wb, ws, sheetName);

    const fileName = isGramSachiv
      ? `Gram_Panchayat_Compliance_${userInfo.panchayat_name?.replace(/\s+/g, '_') || 'MyGP'}.xlsx`
      : "BDPO_Special_GS_Compliance.xlsx";

    XLSX.writeFile(wb, fileName);
  };

  // Grand totals for Gram Sachiv
  const gramSachivTotals = {
    m1_conducted: data.reduce((s, i) => s + (i.m1_conducted || 0), 0),
    m1_updated: data.reduce((s, i) => s + (i.m1_updated || 0), 0),
    m1_quorum_yes: data.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
    m1_quorum_no: data.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),
    m2_conducted: data.reduce((s, i) => s + (i.m2_conducted || 0), 0),
    m2_updated: data.reduce((s, i) => s + (i.m2_updated || 0), 0),
    m2_quorum_yes: data.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
    m2_quorum_no: data.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),
    m3_conducted: data.reduce((s, i) => s + (i.m3_conducted || 0), 0),
    m3_updated: data.reduce((s, i) => s + (i.m3_updated || 0), 0),
    m3_quorum_yes: data.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
    m3_quorum_no: data.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),
    never_rescheduled: data.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
  };

  // Grand totals for Block level (now panchayat-level)
  const blockTotals = {
    m1_conducted: data.reduce((s, i) => s + (i.m1_conducted || 0), 0),
    m1_updated: data.reduce((s, i) => s + (i.m1_updated || 0), 0),
    m1_quorum_yes: data.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
    m1_quorum_no: data.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),
    m2_conducted: data.reduce((s, i) => s + (i.m2_conducted || 0), 0),
    m2_updated: data.reduce((s, i) => s + (i.m2_updated || 0), 0),
    m2_quorum_yes: data.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
    m2_quorum_no: data.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),
    m3_conducted: data.reduce((s, i) => s + (i.m3_conducted || 0), 0),
    m3_updated: data.reduce((s, i) => s + (i.m3_updated || 0), 0),
    m3_quorum_yes: data.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
    m3_quorum_no: data.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),
    never_rescheduled: data.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
  };

  // Get report title based on role
  const getReportTitle = () => {
    if (isGramSachiv) {
      return `Gram Panchayat Meeting Compliance ${userInfo.panchayat_name || ''} (Gram Sachiv)`;
    }
    return "Blockwise Special Gram Sabha Meeting Compliance (BDPO)";
  };

  // Get subtitle based on role
  const getSubtitle = () => {
    if (isGramSachiv) {
      return (
        <>

        </>
      );
    }
    return <>Total Records: <strong>{data.length}</strong> panchayats</>;
  };

  return (
    <div style={{ padding: 24, background: "#f0f2f5", minHeight: "100vh" }}>
      <div
        style={{
          background: "#fff",
          padding: 24,
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: "#1f1f1f" }}>
              {getReportTitle()}
            </h2>
            <p style={{ margin: 0, color: "#666" }}>
              {getSubtitle()}
            </p>
          </div>

          <Space>
            <Button icon={<FilePdfOutlined />} onClick={handleExportPDF}>
              Export PDF
            </Button>
            <Button
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={handleExportExcel}
            >
              Export Excel
            </Button>
            <Button
              icon={<ReloadOutlined />}
              onClick={() => isGramSachiv ? fetchGramSachivData(dateFilter) : fetchBlockReportData(dateFilter)}
            >
              Refresh
            </Button>
          </Space>
        </div>

        {error && <Alert type="error" message={error} showIcon />}

        {loading ? (
          <div style={{ textAlign: "center", padding: 60 }}>
            <Spin size="large" />
            <p style={{ marginTop: 10, color: "#666" }}>
              {isGramSachiv ? 'Loading panchayat data...' : 'Loading block data...'}
            </p>
          </div>
        ) : (
          <Table
            columns={getColumns()}
            dataSource={data}
            bordered
            size="small"
            scroll={{ x: isGramSachiv ? 1800 : 1900, y: 420 }}
            pagination={{
              current: currentPage,
              pageSize: pageSize,
              total: data.length,
              showSizeChanger: true,
              pageSizeOptions: ["10", "20", "50", "100"],
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} records`,
            }}
            onChange={(pagination) => {
              setCurrentPage(pagination.current);
              setPageSize(pagination.pageSize);
            }}
          />
        )}

        {/* Grand Totals Section */}
        {data.length > 0 && isGramSachiv && (
          <div style={{
            marginTop: 12,
            padding: "10px 14px",
            background: "#e6f7ff",
            border: "1px solid #91d5ff",
            borderRadius: 6,
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 12,
          }}>
            <strong>Gram Panchayat Totals:</strong>
            <span>1st Conducted:  <b>{gramSachivTotals.m1_conducted}</b></span>
            <span>1st Updated: <b>{gramSachivTotals.m1_updated}</b></span>
            <span>1st Quorum Yes: <b>{gramSachivTotals.m1_quorum_yes}</b></span>
            <span>1st Quorum No: <b>{gramSachivTotals.m1_quorum_no}</b></span>

            <span>2nd Conducted:  <b>{gramSachivTotals.m2_conducted}</b></span>
            <span>2nd Updated: <b>{gramSachivTotals.m2_updated}</b></span>
            <span>2nd Quorum Yes: <b>{gramSachivTotals.m2_quorum_yes}</b></span>
            <span>2nd Quorum No: <b>{gramSachivTotals.m2_quorum_no}</b></span>

            <span>3rd Conducted: <b>{gramSachivTotals.m3_conducted}</b></span>
            <span>3rd Updated: <b>{gramSachivTotals.m3_updated}</b></span>
            <span>3rd Quorum Yes: <b>{gramSachivTotals.m3_quorum_yes}</b></span>
            <span>3rd Quorum No: <b>{gramSachivTotals.m3_quorum_no}</b></span>

            <span>Never Rescheduled: <b>{gramSachivTotals.never_rescheduled}</b></span>
          </div>
        )}

        {data.length > 0 && !isGramSachiv && (
          <div style={{
            marginTop: 12,
            padding: "10px 14px",
            background: "#e6f7ff",
            border: "1px solid #91d5ff",
            borderRadius: 6,
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 12,
          }}>
            <strong>Grand Totals (All Panchayats):</strong>
            <span>1st Meeting - Cond: <b>{blockTotals.m1_conducted}</b></span>
            <span>Upd: <b>{blockTotals.m1_updated}</b></span>
            <span>QY: <b>{blockTotals.m1_quorum_yes}</b></span>
            <span>QN: <b>{blockTotals.m1_quorum_no}</b></span>
            <span>2nd Meeting - Cond: <b>{blockTotals.m2_conducted}</b></span>
            <span>Upd: <b>{blockTotals.m2_updated}</b></span>
            <span>QY: <b>{blockTotals.m2_quorum_yes}</b></span>
            <span>QN: <b>{blockTotals.m2_quorum_no}</b></span>
            <span>3rd Meeting - Cond: <b>{blockTotals.m3_conducted}</b></span>
            <span>Upd: <b>{blockTotals.m3_updated}</b></span>
            <span>QY: <b>{blockTotals.m3_quorum_yes}</b></span>
            <span>QN: <b>{blockTotals.m3_quorum_no}</b></span>
            <span>Never Rescheduled: <b>{blockTotals.never_rescheduled}</b></span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DistrictwiseSpecialGSComplianceSachiv;